var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBonusesActive(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 35,
    viewBox: "0 0 35 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5 17.5C5 10.625 10.625 5 17.5 5C24.375 5 30 10.625 30 17.5C30 24.375 24.375 30 17.5 30C10.625 30 5 24.375 5 17.5Z",
    fill: "#BFF736"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.78 23.4976C11.78 23.7755 12.0124 24 12.3 24H16.9475V18.0966H11.78V23.4976ZM18.0525 24H22.7C22.9876 24 23.22 23.7755 23.22 23.4976V18.0966H18.0525V24ZM23.48 14.3285H21.0815C21.3025 13.9925 21.4325 13.5937 21.4325 13.1667C21.4325 11.9719 20.4266 11 19.19 11C18.5172 11 17.9111 11.2889 17.5 11.7442C17.0889 11.2889 16.4827 11 15.81 11C14.5734 11 13.5675 11.9719 13.5675 13.1667C13.5675 13.5937 13.6959 13.9925 13.9185 14.3285H11.52C11.2324 14.3285 11 14.553 11 14.8309V17.029H16.9475V14.3285H18.0525V17.029H24V14.8309C24 14.553 23.7676 14.3285 23.48 14.3285ZM16.9475 14.2657H15.81C15.1827 14.2657 14.6725 13.7727 14.6725 13.1667C14.6725 12.5606 15.1827 12.0676 15.81 12.0676C16.4372 12.0676 16.9475 12.5606 16.9475 13.1667V14.2657ZM19.19 14.2657H18.0525V13.1667C18.0525 12.5606 18.5627 12.0676 19.19 12.0676C19.8172 12.0676 20.3275 12.5606 20.3275 13.1667C20.3275 13.7727 19.8172 14.2657 19.19 14.2657Z",
    fill: "#191A1B"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBonusesActive);
export default __webpack_public_path__ + "static/media/bonuses-active.a085066e97589ccbeed3ddfc194b83de.svg";
export { ForwardRef as ReactComponent };